/* eslint-disable react/no-array-index-key */
import React from 'react';
import { modalOverlayStyle } from './styles';

interface ModalConlicitasegEmailProps {
  showEmailModal: boolean;
  setShowEmailModal: (show: boolean) => void;
  newEmail: string;
  setNewEmail: (email: string) => void;
  emails: string[];
  handleAddEmail: () => void;
  handleRemoveEmail: (email: string) => void;
  handleSendEmails: () => void;
}

const ModalConlicitasegEmail: React.FC<ModalConlicitasegEmailProps> = ({
  showEmailModal,
  setShowEmailModal,
  newEmail,
  setNewEmail,
  emails,
  handleAddEmail,
  handleRemoveEmail,
  handleSendEmails,
}) => {
  if (!showEmailModal) return null;

  return (
    <div className="modal fade show d-block" tabIndex={-1} style={modalOverlayStyle}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title">Encaminhar para outro e-mail</h5>
            <button type="button" className="close" onClick={() => setShowEmailModal(false)}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <p className="text-muted mb-3">Informe abaixo os e-mails para envio da documentação</p>

            <div className="mb-3">
              <div className="input-group">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Digite o e-mail"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleAddEmail();
                    }
                  }}
                />
                <div className="input-group-append">
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={handleAddEmail}
                    disabled={!newEmail}
                  >
                    Adicionar
                  </button>
                </div>
              </div>
            </div>

            {emails.map((email, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center mb-3 p-2 bg-light rounded"
              >
                <span>{email}</span>
                <button
                  type="button"
                  className="btn btn-link text-danger p-0"
                  onClick={() => handleRemoveEmail(email)}
                >
                  <i className="fas fa-trash" />
                </button>
              </div>
            ))}
          </div>
          <div className="modal-footer border-0">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSendEmails}
              disabled={emails.length === 0}
            >
              Enviar por e-mail
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConlicitasegEmail;
